import { render, staticRenderFns } from "./sayfaGorseller.vue?vue&type=template&id=3b9ae658&"
import script from "./sayfaGorseller.vue?vue&type=script&lang=js&"
export * from "./sayfaGorseller.vue?vue&type=script&lang=js&"
import style0 from "./sayfaGorseller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports